export const LOGIN = "login";
export const SIGN_UP = "sign-up";
export const LOGIN_ADMIN_INVITE = "/login/invite/admin"; // THE BACKEND EXPECTS THIS PATH. IF UPDATED, NEED TO UPDATE BACKEND.

export const ESA_PARENT_ROUTE = "esa";
export const ADMIN_PARENT_ROUTE = "admin";
export const EMPLOYEE_PARENT_ROUTE = "employee";

// admin sub routes
export const ADMIN_ONBOARDING = "onboarding";
export const ADMIN_HOME = "";
export const ADMIN_DASHBOARD = "dashboard";
export const ADMIN_EMPLOYEES = "employees";
export const ADMIN_PROGRAMS = "programs";
export const ADMIN_SETTINGS = "settings";
export const ADMIN_REPORTS = "reports";

// admin navigation helpers
export const adminOnboardingFullPath = `/${ESA_PARENT_ROUTE}/${ADMIN_PARENT_ROUTE}/${ADMIN_ONBOARDING}`;
export const adminDashboardFullPath = `/${ESA_PARENT_ROUTE}/${ADMIN_PARENT_ROUTE}/${ADMIN_DASHBOARD}`;
export const adminLoginFullPath = `/${ADMIN_PARENT_ROUTE}/${LOGIN}`;
export const adminSignUpFullPath = `/${ADMIN_PARENT_ROUTE}/${SIGN_UP}`;

// employee sub routes
export const EMPLOYEE_ACCOUNT = "account";
export const EMPLOYEE_ACCOUNT_STATUS = "account-status";
export const EMPLOYEE_TRANSFERS = "transfers";
export const EMPLOYEE_TRANSFERS_ADD_MONEY = "add";
export const EMPLOYEE_TRANSFERS_SEND_MONEY = "send";
export const EMPLOYEE_TRANSFER_INITIATED = "transfer-initiated";
export const EMPLOYEE_TRANSFER_ERROR = "transfer-error";
export const EMPLOYEE_SETTINGS = "settings";
export const EMPLOYEE_ACCOUNT_STATEMENTS = "statements";
export const EMPLOYEE_ACCOUNT_INVITE = "invite";
export const EMPLOYEE_ACTIVATE_CARD = "activate-card";
export const EMPLOYEE_DEBIT_CARD_INFO = "card";
export const EMPLOYEE_DEBIT_CARD_CHANGE_PIN = "change-pin";
export const EMPLOYEE_DEBIT_CARD_CHANGE_ADDRESS = "change-address";
export const EMPLOYEE_DEBIT_CARD_NEW_CARD = "new";
export const EMPLOYEE_CHANGE_CONTRIBUTION = "contribution";
export const EMPLOYEE_TRANSACTIONS = "transactions";
export const EMPLOYEE_REQUEST_CARD = "request-card";
export const EMPLOYEE_REQUEST_CARD_SUCCESS = "request-card-success";

// employee navigation helpers
export const employeeLoginFullPath = `/${EMPLOYEE_PARENT_ROUTE}/${LOGIN}`;
export const employeeAccountStatusPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT_STATUS}`;
export const employeeAccountPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}`;
export const employeeAccounInviteCoworkersPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_ACCOUNT_INVITE}`;
export const employeeActivateCardPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_ACTIVATE_CARD}`;
export const employeeDebitCardInfoPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_DEBIT_CARD_INFO}`;
export const employeeDebitCardChangePinPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_DEBIT_CARD_INFO}/${EMPLOYEE_DEBIT_CARD_CHANGE_PIN}`;
export const employeeDebitCardChangeAddressPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_DEBIT_CARD_INFO}/${EMPLOYEE_DEBIT_CARD_CHANGE_ADDRESS}`;
export const employeeDebitCardOrderNewPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_DEBIT_CARD_INFO}/${EMPLOYEE_DEBIT_CARD_NEW_CARD}`;
export const employeeChangeContributionPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_CHANGE_CONTRIBUTION}`;
export const employeeTransactionsPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_TRANSACTIONS}`;
export const employeeTransfersPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_TRANSFERS}`;
export const employeeTransfersAddMoneyPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_TRANSFERS}/${EMPLOYEE_TRANSFERS_ADD_MONEY}`;
export const employeeTransfersSendMoneyPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_TRANSFERS}/${EMPLOYEE_TRANSFERS_SEND_MONEY}`;
export const employeeTransfersInitiated = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_TRANSFER_INITIATED}`; // not a child route b/c it is a full page overlay w/ no sidebar
export const employeeTransfersErrorPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_TRANSFER_ERROR}`; // not a child route b/c it is a full page overlay w/ no sidebar
export const employeeSettingsPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_SETTINGS}`;
export const employeeAccountStatementsPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_SETTINGS}/${EMPLOYEE_ACCOUNT_STATEMENTS}`;
export const employeeRequestCardPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_ACCOUNT}/${EMPLOYEE_SETTINGS}/${EMPLOYEE_REQUEST_CARD}`;
export const employeeRequestCardSuccessPath = `/${ESA_PARENT_ROUTE}/${EMPLOYEE_PARENT_ROUTE}/${EMPLOYEE_REQUEST_CARD_SUCCESS}`;
